import { StyleSheetManager } from 'styled-components';
import namespacePlugin from '../../stylisPlugins/namespacePlugin';
import { jsx as _jsx } from "react/jsx-runtime";
const calculatePlugins = () => {
  if (process.env.STYLE_NAMESPACE) {
    return [namespacePlugin(process.env.STYLE_NAMESPACE)];
  }
  return [];
};

// We only want to calculate the plugins once for any sheet manager in the
// created with code in the same build. If namespacing is enabled in webpack,
// it should be enabled everywhere that this component is used.
let plugins = calculatePlugins();
export const __TEST_ONLY_recalculatePlugins = () => {
  plugins = calculatePlugins();
};
const TrellisStyleSheetManager = ({
  children
}) => {
  return /*#__PURE__*/_jsx(StyleSheetManager, {
    stylisPlugins: plugins,
    children: children
  });
};
export default TrellisStyleSheetManager;